import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  section: {
    width: '100%',
    padding: theme.spacing(10, 3),
    backgroundColor: theme.palette.background.ecosystem,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'background-color 0.3s ease',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(12, 8),
    },
  },

  header: {
    textAlign: 'center',
    marginBottom: theme.spacing(8),
  },

  overline: {
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '0.25em',
    textTransform: 'uppercase',
    color: theme.palette.text.ecosystemHeader,
    margin: 0,
  },

  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: theme.spacing(4),
    width: '100%',
    maxWidth: '1000px',
    textAlign:'left',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '1fr 1fr',
    },
  },

  tiltCard: {
    opacity: 0,
    transform: 'translateY(30px)',
    transition: 'opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)',
    transformStyle: 'preserve-3d',
    perspective: '1000px',
  },

  visible: {
    opacity: 1,
    transform: 'translateY(0)',
  },

  tiltInner: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '24px',
    padding: theme.spacing(6),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    transition: 'transform 0.15s ease-out, box-shadow 0.3s ease',
    cursor: 'default',
    '&:hover': {
      boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
    },
  },

  cardGreen: {
    backgroundColor: theme.palette.mode === 'dark'
      ? 'rgba(6, 232, 159, 0.06)'
      : 'rgba(240, 253, 244, 0.9)',
    border: theme.palette.mode === 'dark'
      ? '1px solid rgba(6, 232, 159, 0.15)'
      : '1px solid rgba(0, 110, 47, 0.08)',
  },

  cardBlue: {
    backgroundColor: theme.palette.mode === 'dark'
      ? 'rgba(88, 189, 253, 0.06)'
      : 'rgba(239, 246, 255, 0.9)',
    border: theme.palette.mode === 'dark'
      ? '1px solid rgba(88, 189, 253, 0.15)'
      : '1px solid rgba(0, 88, 190, 0.08)',
  },

  glare: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    transition: 'opacity 0.3s ease',
    mixBlendMode: 'overlay',
    zIndex: 1,
  },

  iconWrapper: {
    width: '56px',
    height: '56px',
    borderRadius: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(4),
    transition: 'transform 0.3s ease',
    '$tiltInner:hover &': {
      transform: 'scale(1.12) rotate(-4deg)',
    },
  },

  iconGreen: {
    backgroundColor: theme.palette.mode === 'dark'
      ? 'rgba(6, 232, 159, 0.15)'
      : '#dcfce7',
  },

  iconBlue: {
    backgroundColor: theme.palette.mode === 'dark'
      ? 'rgba(88, 189, 253, 0.15)'
      : '#dbeafe',
  },

  iconEmoji: {
    fontSize: '26px',
    lineHeight: 1,
  },

  cardTitle: {
    fontSize: '28px',
    fontWeight: 700,
    letterSpacing: '-0.02em',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
    marginTop: 0,
    transition: 'color 0.3s ease',
    fontFamily: '"Montserrat", sans-serif',
  },

  cardDescription: {
    fontSize: '15px',
    lineHeight: 1.6,
    color: theme.palette.mode === 'dark'
      ? 'rgba(255,255,255,0.5)'
      : '#64748b',
    marginBottom: theme.spacing(5),
    marginTop: 0,
  },

  itemList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    marginTop: 'auto',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },

  itemRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    transition: 'transform 0.2s ease',
    '&:hover': {
      transform: 'translateX(6px)',
    },
  },

  checkIcon: {
    width: '22px',
    height: '22px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: 700,
    flexShrink: 0,
  },

  checkGreen: {
    backgroundColor: theme.palette.mode === 'dark'
      ? 'rgba(6, 232, 159, 0.2)'
      : '#bbf7d0',
    color: theme.palette.mode === 'dark' ? '#06E89F' : '#006e2f',
  },

  checkBlue: {
    backgroundColor: theme.palette.mode === 'dark'
      ? 'rgba(88, 189, 253, 0.2)'
      : '#bfdbfe',
    color: theme.palette.mode === 'dark' ? '#58BDFD' : '#0058be',
  },

  itemText: {
    fontSize: '15px',
    color: theme.palette.mode === 'dark'
      ? 'rgba(255,255,255,0.65)'
      : '#475569',
    fontFamily: '"Montserrat", sans-serif',
  },
}));

export default useStyles;